var _SkipEnumerator_enumerator, _SkipEnumerator_itemsToSkip, _SkipEnumerator_currentItem, _SkipEnumerator_count;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import Exception from '../Exceptions/Exception';
export default class SkipEnumerator extends EnumeratorBase {
    constructor(enumerator, itemsToSkip) {
        super();
        _SkipEnumerator_enumerator.set(this, void 0);
        _SkipEnumerator_itemsToSkip.set(this, void 0);
        _SkipEnumerator_currentItem.set(this, void 0);
        _SkipEnumerator_count.set(this, void 0);
        __classPrivateFieldSet(this, _SkipEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _SkipEnumerator_itemsToSkip, itemsToSkip, "f");
        __classPrivateFieldSet(this, _SkipEnumerator_count, 0, "f");
    }
    get current() {
        if (__classPrivateFieldGet(this, _SkipEnumerator_currentItem, "f") === undefined) {
            throw new Exception("Current is undefined");
        }
        return __classPrivateFieldGet(this, _SkipEnumerator_currentItem, "f");
    }
    moveNext() {
        __classPrivateFieldSet(this, _SkipEnumerator_currentItem, this.peek(), "f");
        if (__classPrivateFieldGet(this, _SkipEnumerator_currentItem, "f") === undefined) {
            return false;
        }
        return __classPrivateFieldGet(this, _SkipEnumerator_enumerator, "f").moveNext();
    }
    peek() {
        var _a;
        while (__classPrivateFieldGet(this, _SkipEnumerator_count, "f") < __classPrivateFieldGet(this, _SkipEnumerator_itemsToSkip, "f")) {
            if (!__classPrivateFieldGet(this, _SkipEnumerator_enumerator, "f").moveNext()) {
                return undefined;
            }
            __classPrivateFieldSet(this, _SkipEnumerator_count, (_a = __classPrivateFieldGet(this, _SkipEnumerator_count, "f"), _a++, _a), "f");
        }
        return __classPrivateFieldGet(this, _SkipEnumerator_enumerator, "f").peek();
    }
    reset() {
        __classPrivateFieldSet(this, _SkipEnumerator_count, 0, "f");
        __classPrivateFieldGet(this, _SkipEnumerator_enumerator, "f").reset();
    }
}
_SkipEnumerator_enumerator = new WeakMap(), _SkipEnumerator_itemsToSkip = new WeakMap(), _SkipEnumerator_currentItem = new WeakMap(), _SkipEnumerator_count = new WeakMap();
